import { getStorageNormal, setStorage } from "../globals/storage";
import g from "../globals/variables";

const Contact = (target) => {

  let filterData  = {
    "date": [],
    "targetGroup": [],
    "price": [],
    "mediaType": [],
    "adType": [],
  };
  const el = {
    contactForm: <HTMLFormElement>target,
  };

  const method = {

    init: () => {

      if (el.contactForm) {
        document.querySelector(".assistance__staff").addEventListener("mouseover", () => g.scroll.stop());
        document.querySelector(".assistance__staff").addEventListener("mouseout", () => g.scroll.start());
      }

      method.step1Filter();     

      if (el.contactForm) {       
        for (const [key] of Object.entries(filterData)) {
          var storageInput = <HTMLInputElement>document.getElementsByName(key)[0];
          var storageData = getStorageNormal('session', key);
          storageInput.value = storageData;
        }

        el.contactForm.addEventListener('submit', e => {
            e.preventDefault();
  
            const data = new FormData(el.contactForm);
    
            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/umbraco/Surface/Contact/ContactForm');
            //xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.responseType = 'json';
    
            xhr.onload = () => {
              if (xhr.status === 200) {
                var repsonseObject = JSON.parse(JSON.stringify(xhr.response));

                console.log(repsonseObject);
                
                var oldMessage = el.contactForm.querySelector('.message');
                if (oldMessage != null) {
                  oldMessage.remove();
                }

                var div = document.createElement('DIV');
                div.classList.add('message')
                div.innerHTML = repsonseObject.message;
                
                if (!repsonseObject.success) {
                  div.classList.add('error');
                }
                else {
                  div.classList.add('success');
                  el.contactForm.reset();
                }
                el.contactForm.appendChild(div);
              }
            };
    
            xhr.send(data);
          });
        }
      
    },

    step1Filter: () => {
      const step1Filtes = document.querySelectorAll('.assistance__filters');

      for(let i = 0; i < step1Filtes.length; i++) {
        const step1Filter = step1Filtes[i];
        const step1FilterType = step1Filter.getAttribute('data-type');

        const checkboxes = step1Filter.querySelectorAll('input[type="checkbox"]');

        for (let j = 0; j < checkboxes.length; j++) {
          let checkbox = <HTMLInputElement> checkboxes[j];
          const checkboxValue = checkbox.getAttribute('data-value');

          for (const [key] of Object.entries(filterData)) {
            var storageData = getStorageNormal('session', key);
            if (storageData != null) {
              filterData[key] = storageData.split(',');
              if (storageData.includes(checkboxValue)) {
                checkbox.checked = true;
              }
            }
          }

          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                filterData[step1FilterType].push(checkboxValue);         
            }
            else {
              let index = filterData[step1FilterType].indexOf(checkboxValue);

              if (index > -1) {
                filterData[step1FilterType].splice(index, 1);
              }   
            }
            for (const [key, value] of Object.entries(filterData)) {
              setStorage('session', key, value.join());
            }
          });
        }
      }
    },

  };

  method.init();
};

export default Contact;
